export default function buildSlug (entry) {
    let slug = entry.slug ? entry.slug : entry.title
    if (!slug) throw Error(`${JSON.stringify(entry).slice(0, 30)}\nBlog entry must contain title or slug`)
    return slug
        // lower case the slug
        .toLowerCase()
        // only keep letters numbers dashes and spaces
        .replace(/[^A-Za-z0-9-\s]/g, '')
        // replace spaces and underscores with dashes
        .replace(/\s+|_+/g, '-')
}